module.exports = {"610923100":"城关镇","610923101":"四亩地镇","610923102":"江口镇","610923104":"广货街镇","610923105":"龙王镇","610923106":"筒车湾镇","610923108":"金川镇","610923109":"皇冠镇","610923110":"太山庙镇","610923111":"梅子镇","610923113":"新场镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610923.json
// module id = 3014
// module chunks = 0